<app-dialog-heading [heading]="'Department of Home Affairs Person Profile'"></app-dialog-heading>

<div *ngIf="deathStatus != null">
  
  <div class="clearfix">
    
    <!-------------------------------------->
    <!-- Left Section-->
    <!-------------------------------------->
    
    <div class="md-col md-col-6">
      <div class="flex flex-column">
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="deathStatus.idNumber" [label]="'ID Number'"></app-content-field>
          </div>
        </div>
        
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="deathStatus.idBlocked" [label]="'ID Blocked'"></app-content-field>
          </div>
        </div>
        
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="fullNameDisplayString()" [label]="'Full Name'"></app-content-field>
          </div>
        </div>
        
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="deathStatus.maritalStatus" [label]="'Marital Status'"></app-content-field>
          </div>
        </div>
        
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="deathStatus.dateOfBirth" [label]="'Date of Birth'"></app-content-field>
          </div>
        </div>
        
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="deathStatus.residentialAddress | slice: 0 : 50"
                               [label]="'Residential Address'"></app-content-field>
          </div>
        </div>
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="deathStatus.cellularNumber" [label]="'Cellular Number'"></app-content-field>
          
          </div>
        </div>
        
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="deathStatus.created |  date: dateFormat"
                               [label]="'Last Updated'"></app-content-field>
          </div>
        </div>
      </div>
    </div>
    
    <!-------------------------------------->
    <!-- Right Section-->
    <!-------------------------------------->
    
    <div class="md-col md-col-6">
      <div class="flex flex-column">
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="idMatchedDisplayString()" [label]="'ID Matched'"></app-content-field>
          </div>
        </div>
        
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="deathStatus.idIssueDate" [label]="'ID Issue Date'"></app-content-field>
          </div>
        </div>
        
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="deathStatus.deathStatus" [label]="'Death Status'"></app-content-field>
          </div>
        </div>
        
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="deathStatus.gender" [label]="'Gender'"></app-content-field>
          </div>
        </div>
        
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="deathStatus.placeOfBirth | slice: 0 : 50"
                               [label]="'Place of Birth'"></app-content-field>
          </div>
        </div>
        
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="deathStatus.postalAddress | slice: 0 : 50"
                               [label]="'Postal Address'"></app-content-field>
          </div>
        </div>
        
        <div class="col-12">
          <div class="center-align">
            <app-content-field [content]="deathStatus.employerDetail | slice: 0 : 50"
                               [label]="'Employer'"></app-content-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="deathStatus == null" class="center">
  <p>There are no details for this person yet.</p>
  <p>Click the update button to retrieve the person's details.</p>
  <p>Note that this will be done automatically when a claim is submitted.</p>
</div>
<mat-dialog-actions align="center" class="dialog-button-container">
  <button (click)="updateDeathStatus()" [disabled]="disableUpdateButton()" class="dialog-button" color="primary"
          mat-raised-button>
    Update
    <mat-icon *ngIf="disableUpdateButton()" class="info-icon"
              matTooltip="Only managers and claims team leaders can manually re-check the details for a person.">
      help_outline
    </mat-icon>
  </button>
</mat-dialog-actions>
